<template>
  <div id="app" >
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  watch: {
  }
}
</script>

<style>
  html,body,#app{
    height: 100%;
    overflow-y: hidden;
  }
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.current_location p:first-child{
  font-size: 28px;
  color: #282828;
  font-weight: 600;
  margin-bottom: 15px;
}
.current_location p:last-child{
  font-size: 18px;
  color: #282828;
}
.current_location p:last-child>span{
  color: #818181;
}
</style>



// WEBPACK FOOTER //
// src/App.vue